import React from 'react';

import styles from './styles/totalBar.scss';

const ActionsList = (props) => {

    const {children} = props;

    return (
        <div className={styles.lista_acoes}>
            {children}        
        </div>
    );
};

export {ActionsList};